import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {
    AbstractLiveModel,
    ChartAssetAlertHistoryResponse,
    ChartModelAlertHistoryResponse,
    ChartModelHistoryResponse,
    FleetLatestStatusResponse,
    LiveAssetRequest,
    LiveFleetRequest,
    LiveModelRequest,
    LiveService,
} from '@core/interfaces/live/live';
import {LiveApi} from '../../api/live/live.api';
import {APIResponse, Filter} from '@core/interfaces/system/system-common';
import {GuideInfo} from '@theme/components';
import {LiveConfig} from '@core/interfaces/common/configuration';

@Injectable()
export class LiveServiceImpl extends LiveService {
    constructor(private api: LiveApi) {
        super();
    }

    /*
     * Data explorer
     */
    getMeterDataDatasource(): Observable<DataSource> {
        return this.api.getMeterDataDatasource();
    }

    getLiveConfiguration(): Observable<APIResponse<LiveConfig>> {
        return this.api.getLiveConfiguration();
    }

    /*
     * Generic
     */
    getSearchAssetIds(assetId: string, model: string, asOf: string): Observable<APIResponse<string[]>> {
        return this.api.getSearchAssetIds(assetId, model, asOf);
    }

    getSearchModels(assetId: string, model: string, asOf: string): Observable<APIResponse<string[]>> {
        return this.api.getSearchModels(assetId, model, asOf);
    }

    /*
     * Model, generic
     */
    public getCountResultsByModel(request: LiveModelRequest): Observable<number> {
        return this.api.getCountResultsByModel(request);
    }

    getChartModelHistory(request: LiveModelRequest): Observable<APIResponse<ChartModelHistoryResponse>> {
        return this.api.getChartModelHistory(request);
    }

    getChartModelAlertHistory(
        request: LiveModelRequest,
        groupBy: string,
    ): Observable<APIResponse<ChartModelAlertHistoryResponse>> {
        return this.api.getChartModelAlertHistory(request, groupBy);
    }

    /*
     * Asset
     */
    public getCountResultsByAsset(assetId: string, uploadDate: string): Observable<number> {
        return this.api.getCountResultsByAsset(assetId, uploadDate);
    }

    getChartAssetAlertHistory(request: LiveAssetRequest): Observable<APIResponse<ChartAssetAlertHistoryResponse[]>> {
        return this.api.getChartAssetAlertHistory(request);
    }

    getAssetLatestModelStatus(id: string, uploadDate: string): Observable<AbstractLiveModel[]> {
        return this.api.getAssetLatestModelStatus(id, uploadDate);
    }

    /*
     * Fleet
     */
    public getCountResultsByFleet(uploadDate: string): Observable<number> {
        return this.api.getCountResultsByFleet(uploadDate);
    }

    getFleetLatestStatusDetails(request: LiveFleetRequest): Observable<APIResponse<FleetLatestStatusResponse>> {
        return this.api.getFleetLatestStatusDetails(request);
    }

    getCurrentAssetAlerts(request: LiveFleetRequest, filters?: Filter[]): Observable<DataSource> {
        return this.api.getCurrentAssetAlerts(request, filters);
    }

    public getGuideInfo(modelId: string): Observable<GuideInfo[]> {
        return this.api.getGuideInfo(modelId);
    }
}
